var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import ContentTemplateDomainService from "../Domain/ContentTemplate/ContentTemplate.service";
export default class ContentTemplateService {
    static searchCampaignTemplates(search = {}, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield FetchService.getPagedResponse("/aviso/contentTemplate/searchCampaignContentTemplates", {
                ids: search.ids,
                query: search.query,
                createdById: search.createdById,
                modifiedById: search.modifiedById,
                createdBefore: search.createdBefore,
                createdAfter: search.createdAfter,
                modifiedBefore: search.modifiedBefore,
                modifiedAfter: search.modifiedAfter,
                isSimpleBody: search.isSimpleBody,
                isExpired: search.isExpired,
                expiredBefore: search.expiredBefore,
                expiredAfter: search.expiredAfter,
                expiredById: search.expiredById,
                campaignTypeIds: search.campaignTypeIds,
                max: options.max,
                offset: options.offset,
                sort: options.sort,
                order: options.order,
                virtualizedAppName: search.virtualizedAppName,
            });
            return Object.assign(Object.assign({}, response), { 
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                data: response.data.map(ContentTemplateDomainService.fromJSON) });
        });
    }
    static getCampaignTemplate(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield FetchService.getSingleResponse("/aviso/contentTemplate/getCampaignContentTemplate", { id }).then(ContentTemplateDomainService.fromJSON);
            if (resp.typeId !== ContentTemplateDomainService.Types.CampaignContentTemplate) {
                throw new Error("Expected to get a campaign content template, but got another type");
            }
            return resp;
        });
    }
    static save(request) {
        return FetchService.postSingleResponse("/aviso/contentTemplate/save", request);
    }
    static saveCampaignContentTemplate(request) {
        return FetchService.postSingleResponse("/aviso/contentTemplate/saveCampaignContentTemplate", request);
    }
    static deleteCampaignContentTemplate({ id }) {
        return FetchService.deleteSingleResponse("/aviso/contentTemplate/deleteCampaignContentTemplate", { id });
    }
}
